import { Form } from '@vivaldis/antd-ui'
import { ActionBar } from './components/ActionBar'
import { FormContent } from './components/FormContent'
import { AiSuggestionProvider } from './providers/AiSuggestionProvider'
import { FormProvider, WorkPostSheetFormValues } from './providers/FormProvider'
import { StepProvider } from './providers/StepProvider'
import {
  AiSuggestedWorkPostSheet,
  PositionWithWPS,
  WorkPostSheet
} from './types'

interface WorkPostSheetFormProps {
  onSubmit: (values: WorkPostSheetFormValues) => Promise<any>
  workPostSheet?: WorkPostSheet | null
  positionsWithWPS?: PositionWithWPS[]
  aiSuggestedWorkPostSheet?: AiSuggestedWorkPostSheet | null
  buttonText: string
}

export const WorkPostSheetForm = ({
  onSubmit,
  workPostSheet,
  positionsWithWPS,
  aiSuggestedWorkPostSheet,
  buttonText
}: WorkPostSheetFormProps) => {
  return (
    <StepProvider>
      <FormProvider
        workPostSheet={workPostSheet}
        aiSuggestedWorkPostSheet={aiSuggestedWorkPostSheet}
        onSubmit={onSubmit}
      >
        <AiSuggestionProvider
          aiSuggestedWorkPostSheet={aiSuggestedWorkPostSheet}
        >
          <Form name="wps-form">
            <FormContent positionsWithWPS={positionsWithWPS} />
            <ActionBar buttonText={buttonText} />
          </Form>
        </AiSuggestionProvider>
      </FormProvider>
    </StepProvider>
  )
}
